/* ---------------------------------------------------------------
   Lin & Lore - e-mailadres tonen zonder link

   WAAROM
   Bewuste keuze van Sem, 07-09-2026: een klikbaar adres nodigt uit tot
   "even een mailtje sturen". Het contactformulier op /pages/contact blijft
   laagdrempelig.

   LEGE LINKS
   Een lege <a href="mailto:..."></a> verwijderen we; we vullen hem niet met
   het adres uit het href. De zichtbare tekst is altijd leidend.

   HET DODE ADRES
   info@linlore.com is nooit van ons geweest; dit script zet het goede adres
   neer. Sinds 18-10-2026 is dat info@lin-lore.com (AU/NZ).
   --------------------------------------------------------------- */

(function () {
  'use strict';

  var GOED = 'info@lin-lore.com';
  var FOUT = /info@linlore\.com/gi;

  function stijl() {
    if (document.getElementById('ll-mail-stijl')) return;
    var s = document.createElement('style');
    s.id = 'll-mail-stijl';
    s.textContent = '.ll-mail{white-space:nowrap;font-weight:600;color:inherit}';
    document.head.appendChild(s);
  }

  function ontkoppel() {
    var links = document.querySelectorAll('a[href^="mailto:" i]');
    for (var i = 0; i < links.length; i++) {
      var a = links[i];
      if (!a.parentNode) continue;

      var tekst = (a.textContent || '').trim();

      if (!tekst) {
        a.parentNode.removeChild(a);
        continue;
      }

      var el = document.createElement('strong');
      el.className = 'll-mail';
      el.textContent = tekst.replace(FOUT, GOED);
      a.parentNode.replaceChild(el, a);
    }
  }

  function corrigeerTekst() {
    var loop = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        if (!n.nodeValue || n.nodeValue.indexOf('linlore.com') === -1) return NodeFilter.FILTER_REJECT;
        var o = n.parentNode && n.parentNode.nodeName;
        if (o === 'SCRIPT' || o === 'STYLE' || o === 'TEXTAREA') return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    var raak = [], n;
    while ((n = loop.nextNode())) raak.push(n);
    for (var i = 0; i < raak.length; i++) {
      raak[i].nodeValue = raak[i].nodeValue.replace(FOUT, GOED);
    }
  }

  function draai() {
    stijl();
    ontkoppel();
    corrigeerTekst();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', draai);
  } else {
    draai();
  }
})();
